import { useRef } from 'react';
import {
	Flex,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalOverlay,
} from '@chakra-ui/react';
import Webcam from 'react-webcam';

import { Buttons } from './styles';

const videoConstraints = {
	width: 720,
	height: 720,
	facingMode: "user"
};

interface WebCamModalProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	setImg: (image:  any) => void;
	setFotoUrl: (url: any) => void;
};

const WebCamModal: React.FC<WebCamModalProps> = ({
	isOpen,
	onRequestClose,
	setImg,
	setFotoUrl
}) => {
	const camRef = useRef<Webcam>(null);

	async function handleCaptureImage() {
		const imageSrc = camRef.current?.getScreenshot();

		if (imageSrc) {
			// const aux: any = await handleResizeFile(imageSrc);
			console.log('imageSrc => ', imageSrc);

			setImg(imageSrc);
			setFotoUrl(imageSrc);
			
			onRequestClose(false);
		}
	}

	return (
		<Modal
			isCentered={true}
			closeOnOverlayClick={false}
			blockScrollOnMount={false}
			size="lg"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />

			<ModalContent>
				<ModalBody  px={2} pt={2}>
					<Flex>
						<Webcam
							audio={false}
							height={720}
							width={720}
							screenshotFormat="image/png"
							screenshotQuality={1}
							videoConstraints={videoConstraints}
							ref={camRef}
						/>
					</Flex>
				</ModalBody>

				<ModalFooter py={0} px={0} pb={2}>
					<Buttons>
						<button
							type="button"
							className="button-cancel"
							onClick={() => onRequestClose(false)}
						>
							Fechar
						</button>

						<button
							type="submit"
							className="button-save"
							onClick={handleCaptureImage}
						>
							&nbsp;&nbsp;&nbsp;Tirar&nbsp;&nbsp;&nbsp;
						</button>
					</Buttons>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}

export default WebCamModal;